<div class="chat-export-form-layout" [testId]="'chat-export-form-layout'">
  <!-- 左侧：建立汇出表单 -->
  <article class="export-card create-card" [testId]="'chat-export-create-card'">
    <h2 class="card-title">{{ 'servicenumber.chat-export.choose-month' | i18n }}</h2>
    <p class="card-subtitle muted">
      {{ 'servicenumber.chat-export.timezone-tip' | i18n: { tz: timeZone } }}
    </p>

    <div class="field-group">
      <label for="chat-export-month-input">{{ 'servicenumber.chat-export.data-month' | i18n }}</label>
      <input
        type="month"
        id="chat-export-month-input"
        class="month-input"
        [ngModel]="selectedMonth"
        (ngModelChange)="onMonthChange($event)"
        [max]="maxMonth"
        [disabled]="!canManage || submitting"
        [testId]="'chat-export-month-picker'"
      />
      <div class="range-hint muted" *ngIf="rangeText" [testId]="'chat-export-range-hint'">
        {{ rangeText }}
      </div>
    </div>

    <!-- 动态可用性状态 Banner -->
    <div [class]="eligibilityBannerClass" role="status" [testId]="'chat-export-eligibility-banner'">
      <i nz-icon [nzType]="eligibility === 'CAN_EXPORT' ? 'check-circle' : 'info-circle'" nzTheme="outline"></i>
      <span>{{ eligibilityBannerKey | i18n }}</span>
    </div>

    <!-- 动作按钮区 -->
    <div class="form-actions" [testId]="'chat-export-form-actions'">
      <button
        nz-button
        nzType="primary"
        class="action-btn"
        [disabled]="!canSubmit"
        [nzLoading]="submitting"
        (click)="onSubmit()"
        [testId]="'chat-export-submit-button'"
      >
        <i nz-icon nzType="download" nzTheme="outline"></i>
        {{ 'servicenumber.chat-export.submit-btn' | i18n }}
      </button>

      <button
        nz-button
        nzType="default"
        class="action-btn"
        *ngIf="showExistingButton"
        (click)="onViewRecords()"
        [testId]="'chat-export-view-existing-button'"
      >
        <i nz-icon nzType="unordered-list" nzTheme="outline"></i>
        {{ 'servicenumber.chat-export.view-existing-btn' | i18n }}
      </button>

      <button nz-button nzType="default" class="action-btn" (click)="onPreviewStyle()" [testId]="'chat-export-preview-style-button'">
        <i nz-icon nzType="eye" nzTheme="outline"></i>
        {{ 'servicenumber.chat-export.preview-style-btn' | i18n }}
      </button>
    </div>

    <p class="bottom-tip muted">
      {{ 'servicenumber.chat-export.duplicate-export-tip' | i18n }}
    </p>
  </article>

  <!-- 右侧：规格说明卡片 -->
  <aside class="export-card guide-card soft-bg" [testId]="'chat-export-guide-card'">
    <h3 class="guide-title">{{ 'servicenumber.chat-export.full-month-title' | i18n }}</h3>
    <ul class="guide-list">
      <li>{{ 'servicenumber.chat-export.guide-item-1' | i18n }}</li>
      <li>{{ 'servicenumber.chat-export.guide-item-2' | i18n }}</li>
      <li>{{ 'servicenumber.chat-export.guide-item-3' | i18n }}</li>
      <li>{{ 'servicenumber.chat-export.guide-item-4' | i18n }}</li>
    </ul>

    <h3 class="guide-title section-gap">{{ 'servicenumber.chat-export.storage-auth-title' | i18n }}</h3>
    <p class="guide-desc">
      {{ 'servicenumber.chat-export.storage-auth-desc' | i18n }}
    </p>
    <p class="guide-desc muted">
      {{ 'servicenumber.chat-export.backend-queue-desc' | i18n }}
    </p>
  </aside>
</div>
